import { Link } from 'react-router-dom';
import { footerLinks, brandInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-white/90">
      <div className="px-4 md:px-6 lg:px-10 py-14 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12">
          <div className="md:col-span-1">
            <h4 className="font-heading text-xl font-semibold text-white mb-4">
              {brandInfo.name}
            </h4>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              策點文化 StratDot 為崧博出版合作經銷品牌之一，以精選與閱讀策展為核心，涵蓋茶書、商業、科普、醫療保健、大眾心理學與人文社科。正式書目請以崧博出版書籍資料庫為準，價格、庫存及購買方式則以各合作通路頁面為準。
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-white/90 uppercase tracking-wider mb-4">
              快速連結
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith('/') ? (
                    <Link
                      to={link.href}
                      className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} 策點文化事業有限公司。保留所有權利。
          </p>
        </div>
      </div>
    </footer>
  );
}
